import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import NavBar from "./components/navBar";
import Footer from "./components/footer";

import Home from "./pages/home";
import About from "./pages/about";
import OurWork from "./pages/OurWork";
import Contact from "./pages/contact";
import SingleWork from "./pages/SingleWork";

import ScrollToTop from "./ScrollToTop";
import "./App.css";

/* ADMIN */
import AdminLogin from "./admin/Login";
import Dashboard from "./admin/Dashboard";
import AddCard from "./admin/AddCard";
import ManageCards from "./admin/ManageCards";
import EditCard from "./admin/EditCard";
import AdminPreview from "./admin/AdminPreview";

/* PROTECTED ROUTE */
const PrivateRoute = ({ children }) => {
  const isAdmin = localStorage.getItem("admin");
  return isAdmin ? children : <Navigate to="/super-secret-login-3921" replace />;
};

function App() {
  useEffect(() => {
    const themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) {
      themeMeta.setAttribute("content", "#f5efe8");
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* ===== PUBLIC ROUTES ===== */}
        <Route
          path="/"
          element={
            <>
              <NavBar />
              <Home />
              <Footer />
            </>
          }
        />

        <Route
          path="/about"
          element={
            <>
              <NavBar />
              <About />
              <Footer />
            </>
          }
        />

        <Route
          path="/our-work"
          element={
            <>
              <NavBar />
              <OurWork />
              <Footer />
            </>
          }
        />

        {/* Single work page */}
        <Route
          path="/work/:id"
          element={
            <>
              <NavBar />
              <SingleWork />
              <Footer />
            </>
          }
        />

        <Route
          path="/contact"
          element={
            <>
              <NavBar />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* ===== ADMIN ROUTES ===== */}
        <Route path="/super-secret-login-3921" element={<AdminLogin />} />

        <Route
          path="/super-secret-dashboard-4821"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        <Route
          path="/super-secret-add-card"
          element={
            <PrivateRoute>
              <AddCard />
            </PrivateRoute>
          }
        />

        <Route
          path="/super-secret-work-cards"
          element={
            <PrivateRoute>
              <ManageCards />
            </PrivateRoute>
          }
        />

        <Route
          path="/edit-card/:id"
          element={
            <PrivateRoute>
              <EditCard />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-preview/:id"
          element={
            <PrivateRoute>
              <AdminPreview />
            </PrivateRoute>
          }
        />

        {/* ===== FALLBACK ===== */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
